export function Field({ label, error, children, required }) {
  return (
    <div className={`field ${error ? 'field-has-error' : ''}`}>
      <span className="field-label">
        {label}
        {required && <span className="required">*</span>}
      </span>
      {children}
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}

export function Input({ register, name, registerOptions, type = 'text', onBlur: onBlurExtra, ...rest }) {
  const { onBlur, ...reg } = register(name, registerOptions);
  return (
    <input
      className="input"
      type={type}
      {...reg}
      onBlur={(e) => {
        onBlur(e);
        onBlurExtra?.(e);
      }}
      {...rest}
    />
  );
}

export function Select({ register, name, options, registerOptions, placeholder = 'Select…' }) {
  return (
    <select className="input" {...register(name, registerOptions)}>
      <option value="">{placeholder}</option>
      {options.map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export function Textarea({ register, name, registerOptions, rows = 4, ...rest }) {
  return (
    <textarea
      className="input textarea"
      rows={rows}
      {...register(name, registerOptions)}
      {...rest}
    />
  );
}

export function RadioGroup({ register, name, options, registerOptions }) {
  return (
    <div className="radio-group">
      {options.map(([value, label]) => (
        <label key={value} className="radio-item">
          <input type="radio" value={value} {...register(name, registerOptions)} />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
}

export function CheckboxGroup({ value = [], onChange, options }) {
  const toggle = (key) => {
    if (value.includes(key)) {
      onChange(value.filter((v) => v !== key));
    } else {
      onChange([...value, key]);
    }
  };

  return (
    <div className="checkbox-group">
      {options.map(([key, label]) => (
        <label key={key} className="checkbox-item">
          <input
            type="checkbox"
            checked={value.includes(key)}
            onChange={() => toggle(key)}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
}
